import { Tabs, styled, alpha } from "@mui/material";

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  width: "100%",
  height: "100%",
  boxShadow: "none",
  gap: `${theme.spacing(4)} !important`,
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.mode === "dark"
    ? alpha(theme.palette.background.paper, 0.6)
    : theme.palette.background.paper,
  fontSize: theme.typography.caption.fontSize,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 12,
  padding: theme.spacing(0.5, 1),
  border: `1px solid ${theme.palette.divider}`,

  "& .MuiTabs-indicator": {
    display: "none",
  },
}));
